export const buildServicePlanRelationParams = () => ({
  relations: ['author', 'status'],
});